import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/masterdata-api/business-role/page', params)

// 删除
export const removeItem = id => request.get(`/masterdata-api/role/delete/${id}`)

// 新增或更新菜单
export const updateOrAdd = params =>
  request.post('/masterdata-api/business-role/add', params)

export const getAssign = () => request.get(`/masterdata-api/user/active/query`)
